function getJSON(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        Object.assign(xhr, {
            withCredentials: true,
            onload: () => {
                try {
                    resolve(JSON.parse(xhr.response));
                } catch (e) {
                    reject();
                }
            },
            onerror: () => reject()
        });

        xhr.open('GET', url);
        xhr.send(null);
    });
}

module.exports = {
    getJSON
};


// WEBPACK FOOTER //
// ./src/lib/request.js